import { render } from "./SectionC.vue?vue&type=template&id=082f1811&scoped=true"
const script = {}

import "./SectionC.vue?vue&type=style&index=0&id=082f1811&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082f1811"]])

export default __exports__